import { MachineSymbol } from '@cgs/data-access';
import { SlotConfigSymbolDto } from '../../models';

export function symbolMapper(symbol: SlotConfigSymbolDto): MachineSymbol {
  const machineSymbol = new MachineSymbol();
  machineSymbol.id = symbol.id || -1;
  machineSymbol.typeGains = symbol.gains;
  machineSymbol.gains = symbol.gains;
  machineSymbol.stacked = 0;
  machineSymbol.type = symbol.features?.[0] || '';
  return machineSymbol;
}
